<template>
  <v-card class="h-100">
    <v-chart ref="chart" :options="options" :init="chartInit" @contextmenu="contextmenu" />
  </v-card>
</template>

<script>
import chartable from '../../../../mixins/chartable';

export default {
  mixins: [chartable],
  props: {
    system: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    values: {
      type: Array,
      required: true,
    },
    formatter: {
      type: Function,
    },
    max: {
      type: Number,
    },
    grid: {
      type: Object,
      default() {
        return {
          top: '25px',
          bottom: '20px',
          left: '5px',
          right: '5px',
        };
      },
    },
    contextmenu: {
      type: Function,
      default: e => e,
    },
  },
  data: () => ({
    options: {},
    systemChanged: true,
    loading: false,
  }),
  computed: {
    echart() {
      return this.$refs.chart.$refs.chart.chart;
    },
    chartInit() {
      return {
        grid: this.grid,
        xAxis: {
          type: 'category',
          data: [''],
          axisLabel: {
            fontWeight: 'normal',
            fontSize: 9,
            color: '#bbbbaa',
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          max: this.max || 'dataMax',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: params => this.tooltipFormatter(params),
        },
      };
    },
  },
  watch: {
    system: {
      immediate: true,
      handler: 'changSystemHandler',
    },
    items: {
      deep: true,
      handler: 'changItemsHandler',
    },
    values: {
      handler: 'changeValuesHandler',
    },
    isDark: {
      handler: 'changColorHandler',
    },
  },
  methods: {
    changSystemHandler() {
      this.systemChanged = true;
      this.loading = true;
    },
    changItemsHandler() {
      if (!this.systemChanged) this.changColorHandler();
    },
    changeValuesHandler() {
      this.$nextTick(() => {
        if (this.systemChanged) {
          this.options = this.getOptions();
          this.loading = false;
        } else {
          this.options = {
            animation: true,
            series: this.getSeries(),
          };
        }
        this.systemChanged = false;
      });
    },
    changColorHandler() {
      this.options.series.forEach((series, seriesIndex) => {
        series.data.forEach((data, dataIndex) => {
          this.options.series[seriesIndex].data[dataIndex].label.color = this.getThemeColor(this.items[dataIndex].color, 10, 10);
          this.options.series[seriesIndex].data[dataIndex].itemStyle.color = this.getThemeColor(this.values[dataIndex][seriesIndex].color, 10, 10);
          this.options.series[seriesIndex].data[dataIndex].itemStyle.opacity = this.items[dataIndex].active ? 0.8 : 0.1;
        });
      });
    },
    getOptions() {
      return {
        xAxis: {
          //data: this.items.map(item => item.id),
          data: this.items.map(item => item.shortAlias),
        },
        series: this.getSeries(),
      };
    },
    getSeries() {
      if (!this.values.length) return [];
      const types = this.values[0]; // item 별 구성하고 있는 stack 구성 요소
      const series = types.map((type, typeIndex) => ({
        type: 'bar',
        name: type.name,
        stack: 'stack',
        data: this.values.map((value, valueIndex) => ({
          value: value[typeIndex].value,
          label: {
            show: type.name == '_empty', // 마지막 데이터 (empty data) 위치에 label 을 표시.
            position: 'top',
            formatter: () => {
              const content = [];
              content.push(this.values[valueIndex][0].value);
              content.push(' / ');
              content.push(this.values[valueIndex].reduce((acc, item) => (acc += item.value), 0));
              return content.join('');
            },
            color: this.getThemeColor(this.items[valueIndex].color, 10, 10),
          },
          itemStyle: {
            color: this.getThemeColor(value[typeIndex].color, 10, 10),
            opacity: this.items[valueIndex].active ? 0.8 : 0.1,
          },
        })),
      }));
      return series;
    },
    tooltipFormatter(params) {
      //const item = this.items.find(item => item.id == params[0].axisValue);
      const item = this.items.find(item => item.shortAlias == params[0].axisValue);
      if (!item) return '';
      this.$emit('update:selectedDescendant', item);
      //const label = [this.circle(item.color), `<span style="color:${item.color};font-weight:900;">`, item.id, '</span> : '];
      const label = [this.circle(item.color), `<span style="color:${item.color};font-weight:900;">`, item.shortAlias, '</span> : '];
      const values = params.map(param => param.value);
      return [label.join(''), this.formatter(values)].join('');
    },
  },
};
</script>
